import { TIENDA, MENSAJE_COMPRA } from "../data/config";
import { useWhatsApp } from "../hooks/useWhatsApp";
import Boton from "./ui/Boton";
import IconoWhatsApp from "./ui/IconoWhatsApp";
import Reveal from "./ui/Reveal";

const CHIPS = ["100% Maní", "Vegano", "Sin azúcar añadida", "Sin conservantes"];

const INGREDIENTES = [
  "Maní tostado seleccionado (único ingrediente)",
];

const DETALLES = [
  { etiqueta: "Contenido", valor: `Frasco de ${TIENDA.peso}` },
  { etiqueta: "Envíos", valor: `Despacho y entregas a convenir en ${TIENDA.ciudad}` },
  { etiqueta: "Horario de atención", valor: TIENDA.horario },
];

const Producto = () => {
  const { abrirWhatsApp } = useWhatsApp();

  return (
    <section id="producto" className="bg-surface-low py-20 md:py-section">
      <div className="mx-auto max-w-container px-5 md:px-16">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Imagen del producto */}
          <Reveal className="overflow-hidden rounded-xl border border-peanut/40 shadow-card">
            <img
              src="https://images.pexels.com/photos/5149346/pexels-photo-5149346.jpeg?auto=compress&cs=tinysrgb&w=1000"
              alt="Frasco de mantequilla de maní natural Agora abierto mostrando su textura"
              className="aspect-square w-full object-cover"
              loading="lazy"
            />
          </Reveal>

          {/*
            En móvil la información se agrupa dentro de una tarjeta (fondo, borde,
            sombra y padding) para dar contención visual y jerarquía sobre el fondo.
            Desde lg: la tarjeta se desvanece para conservar el look de escritorio.
          */}
          <Reveal
            delay={120}
            className="rounded-xl border border-peanut/40 bg-white p-6 shadow-card sm:p-8 lg:rounded-none lg:border-0 lg:bg-transparent lg:p-0 lg:shadow-none"
          >
            <span className="block text-center text-xs font-semibold uppercase tracking-label text-secondary lg:text-left">
              Nuestro producto
            </span>
            <h2 className="mt-3 text-center font-literata text-2xl font-bold text-charcoal sm:text-3xl md:text-4xl lg:text-left">
              {TIENDA.producto}
            </h2>

            <div className="mt-4 flex flex-col items-center gap-1 lg:flex-row lg:items-baseline lg:justify-start lg:gap-3">
              <span className="font-literata text-4xl font-bold text-charcoal">
                {TIENDA.precioFormateado}
              </span>
              <span className="text-base text-ink-variant">
                Frasco de {TIENDA.peso}
              </span>
            </div>

            {/* Chips de ingredientes/atributos */}
            <ul className="mt-6 flex flex-wrap justify-center gap-3 lg:justify-start">
              {CHIPS.map((chip) => (
                <li
                  key={chip}
                  className="rounded-full border border-peanut/40 bg-peanut/20 px-4 py-2 text-sm font-semibold text-secondary shadow-sm"
                >
                  {chip}
                </li>
              ))}
            </ul>

            {/* Ingredientes */}
            <div className="mt-8 text-left">
              <h3 className="font-literata text-xl font-semibold text-charcoal">
                Ingredientes
              </h3>
              <ul className="mt-3 space-y-2">
                {INGREDIENTES.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-base text-ink-variant">
                    <span className="text-forest" aria-hidden="true">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Detalles de compra y entrega */}
            <dl className="mt-8 space-y-4 border-t border-peanut/40 pt-6">
              {DETALLES.map((detalle) => (
                <div key={detalle.etiqueta} className="flex flex-col gap-1 sm:flex-row sm:gap-4">
                  <dt className="min-w-[16rem] text-xs font-semibold uppercase tracking-label text-secondary">
                    {detalle.etiqueta}
                  </dt>
                  <dd className="text-base text-ink-variant">{detalle.valor}</dd>
                </div>
              ))}
            </dl>

            <Boton
              variante="primario"
              className="mt-10 w-full text-lg sm:w-auto"
              onClick={() => abrirWhatsApp(MENSAJE_COMPRA)}
            >
              <IconoWhatsApp className="text-2xl" />
              Pedir por WhatsApp
            </Boton>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Producto;
